import { Modal } from 'Components';
import styles from './CreateExitModal.module.scss';
import Button from '../Button';

interface ModalProps {
	visible: boolean;
	onCancel: () => void;
	onExit: () => void;
}

const CreateExitModal: React.FC<ModalProps> = ({
	visible,
	onExit,
	onCancel
}) => {
	return (
		<Modal
			visible={visible}
			centered
			onCancel={onCancel}
			footer={null}
			size="xs"
		>
			<div className={styles.header}>Exit Create Assignment</div>
			<div className={styles.description}>
				If you exit now, progress in this setup will not be saved.
			</div>
			<div className={styles.btnContainer}>
				<Button variant="borderless" size="small" onClick={onCancel}>
					Continue creation
				</Button>
				<Button onClick={onExit} size="small">
					Exit and discard
				</Button>
			</div>
		</Modal>
	);
};

export default CreateExitModal;
